<template>
  <page-control :model="page" class="content-container" />
</template>
<script>
import { mapGetters } from 'vuex'
import pageBuilder from '../../services/pageBuilder.js'
import PageControl from '../app/PageControl.vue'

export default {
  name: 'DynamicPagePrototype',
  data: () => ({
    page: {}
  }),
  components: {
    PageControl
  },
  created() {
    this.load()
  },
  methods: {
    load() {
      this.page = {}
      if (this.$store.getters.page && this.$store.getters.page.components) {
        this.page = this.$store.getters.page
      }
    }
  },
  watch: {
    pageState: function () {
      this.load()
    }
  },
  computed: {
    ...mapGetters({
      pageState: 'page'
    })
  },
  async beforeRouteEnter(to, from, next) {
    pageBuilder.loadPage(to, next)
  },
  async beforeRouteUpdate(to, from, next) {
    pageBuilder.loadPage(to, next)
  }
}
</script>
<style lang="scss" >
@import '~vuetify/src/styles/settings/_variables';
@import '@/scss/main.scss';
.content-container {
  @include page-content-style;
}

@media #{map-get($display-breakpoints, 'md-and-down')} {
  .content-container > .content-wrapper.standart .content {
    padding-left: 0.8rem;
    padding-right: 0.8rem;
  }
}
</style>
